module.exports = __webpack_public_path__ + "static/media/_F6-XUnit.b40ed352.svg";